export default __webpack_public_path__ + "static/media/Federal.1677d5a5.svg";